import React, { useState, useEffect, useRef } from "react";
// reactstrap components
import { Col, Row, Progress, Button } from "reactstrap";
import Sound from 'react-sound';
import { base, s3base } from "api.js";
import NoMicrophone from "views/NoMicrophone.jsx";
// import MicRecorder from 'mic-recorder-to-mp3'; // Commented out - replaced with ReusableRecorder
import ReusableRecorder from "components/Recorder/ReusableRecorder.jsx";
import "components/custom.css";
import MicWaveform from "components/Question/Speaking/MicWaveform";
import stopImage from "assets/images/stop recording.png";
import grayImage from "assets/images/gray circle.png";


const IntroTest = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(25);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  // const [intervalId, setIntervalId] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [soundStatus, setSoundStatus] = useState(false);
  const [file, setFile] = useState('');
  const [recordingTimeLeft, setRecordingTimeLeft] = useState(30);
const [recordingProgress, setRecordingProgress] = useState(0);
const [waveformKey, setWaveformKey] = useState(0);
const recordingIntervalRef = useRef(null);
const intervalIdRef = useRef(null);

  // const Mp3RecorderRef = useRef(new MicRecorder({ bitRate: 128 })); // Commented out - replaced with ReusableRecorder
  const recorderRef = useRef(null);

  useEffect(() => {
    if (!props.answer) {
       intervalIdRef.current = setInterval(timer, 1000);
    }

    navigator.mediaDevices.getUserMedia(
      { audio: true },
      () => {
        console.log('Permission Granted');
        setIsBlocked(false);
      },
      () => {
        console.log('Permission Denied');
        setIsBlocked(true);
      }
    );

    return () => {
      clearInterval(intervalIdRef.current);
      clearInterval(recordId);
      if (recordingIntervalRef.current) {
  clearInterval(recordingIntervalRef.current);
}
    };
  }, []);

  const start = () => {
    setSoundStatus(true);
  };

  const handleSongFinishedPlaying = () => {
    if (isBlocked) {
      console.log('Permission Denied');
    } else {
      // Mp3RecorderRef.current = new MicRecorder({ bitRate: 128 }); // Commented out
      // Mp3RecorderRef.current
      //   .start()
      //   .then(() => {
      //     setIsRecording(true);
      //     setBlobURL('');
      //     setSoundStatus(false);
      //   })
      //   .catch((e) => console.error(e));
      
      // New ReusableRecorder implementation
      recorderRef.current?.startRecording();
      setSoundStatus(false);
    }
  };

  const stop = () => {
    if (!isBlocked && isRecording) {
      // Mp3RecorderRef.current // Commented out old implementation
      //   .stop()
      //   .getMp3()
      //   .then(([buffer, blob]) => {
      //     const blobUrl = URL.createObjectURL(blob);
      //     let audioFile = new File([blob], 'noname1' + questionId + '.mp3', {
      //       type: blob.type
      //     });
      //     setBlobURL(blobUrl);
      //     setIsRecording(false);
      //     setRecordCount(100);
      //     setFile(audioFile);
      //     props.submit({ data: audioFile }, true);
      //     props.showResult();
      //   })
      //   .catch((e) => console.log(e));
      
      // New ReusableRecorder implementation
      recorderRef.current?.stopRecording();
    }
  };

  const stopTest = () => {
    if (!isBlocked && isRecording) {
      // Mp3RecorderRef.current // Commented out old implementation
      //   .stop()
      //   .getMp3()
      //   .then(([buffer, blob]) => {
      //     const blobUrl = URL.createObjectURL(blob);
      //     let audioFile = new File([blob], 'noname1.mp3', {
      //       type: blob.type
      //     });
      //     // props.submit({ data: audioFile }, true);
      //     // props.showResult();
      //     // props.nextQuestion({ data: audioFile });
      //   })
      //   .catch((e) => console.log(e));
      
      // New ReusableRecorder implementation
      recorderRef.current?.stopRecording();
    } else {
      // props.nextQuestion({ data: file });
      // props.submit({ data: '' }, true);
    }
  };

  const updateCorrect = () => {
    // props.submit({ data: '' });
    setCorrectFlag(false);
  };

  const skip = () => {
    clearInterval(intervalIdRef.current);
    start();
    const recordInterval = setInterval(timerRecord, 1000);
    setRecordId(recordInterval);
    setSecondCount(0);
  };

  // const timer = () => {
  //   setSecondCount((prevCount) => {
  //     if (prevCount === 1) {
  //       clearInterval(intervalId);
  //       start();
  //       const recordInterval = setInterval(timerRecord, 1000);
  //       setRecordId(recordInterval);
  //     }
  //     return prevCount - 1;
  //   });
  // };

  const timer = () => {
  setSecondCount((prevCount) => {
    if (prevCount === 1) {
      clearInterval(intervalIdRef.current);
      start();
      // Remove this part - no longer needed since handleRecordingStart manages the recording timer
      // const recordInterval = setInterval(timerRecord, 1000);
      // setRecordId(recordInterval);
    }
    return prevCount - 1;
  });
};

  const timerRecord = () => {
    setRecordCount((prevCount) => {
      if (prevCount === 30) {
        clearInterval(recordId);
        stop();
      }
      return prevCount + 1;
    });
  };

  // ReusableRecorder callback handlers
  const handleRecordingComplete = (recordingData) => {
    const audioFile = new File([recordingData.blob], `noname1${questionId}.mp3`, {
      type: 'audio/mp3'
    });
    setBlobURL(recordingData.url);
    setIsRecording(false);
    setRecordCount(100);
    setFile(audioFile);
    // props.submit({ data: audioFile }, true);
    // props.showResult();
  };

const handleRecordingStart = () => {
  setIsRecording(true);
  setBlobURL('');
  setRecordCount(0);
  setRecordingTimeLeft(30);
  setRecordingProgress(0);
  setWaveformKey(prev => prev + 1);
  
  recordingIntervalRef.current = setInterval(() => {
    setRecordCount((prevCount) => {
      const newCount = prevCount + 1;
      // Ensure timeLeft never goes below 0
      const timeLeft = Math.max(30 - newCount, 0);
      setRecordingTimeLeft(timeLeft);
      // Ensure progress never exceeds 100%
      setRecordingProgress(Math.min((newCount / 30) * 100, 100));
      
      if (newCount >= 30) {
        clearInterval(recordingIntervalRef.current);
        recordingIntervalRef.current = null;
        recorderRef.current?.stopRecording();
        return 30; // Cap at 30
      }
      return newCount;
    });
  }, 1000);
};


  // const handleRecordingStop = () => {
  //   setIsRecording(false);
  // };
  
  const handleRecordingStop = () => {
  if (recordingIntervalRef.current) {
    clearInterval(recordingIntervalRef.current);
    recordingIntervalRef.current = null;
  }
  setIsRecording(false);
};

  if (isBlocked) {
    return <NoMicrophone />
  }

  return (
    <>
     <ReusableRecorder
        ref={recorderRef}
        onRecordingComplete={handleRecordingComplete}
        onRecordingStart={handleRecordingStart}
        onRecordingStop={handleRecordingStop}
        maxDuration={30000}
        enableSpeechRecognition={false}
        fileName={`noname1${questionId}.mp3`}
      />
      <Row>
        <Col className="ml-auto mr-auto mock-resource-text" md="10">
          <h3 className="title">Read the prompt below. In 25 seconds, you must reply in your own word, as naturally as clear as possible. You will have 30 seconds to give your response</h3>
        </Col>
      </Row>
      <br />
     {!props.resultMode && (
  <div className="d-flex flex-column justify-content-start align-items-center gap-3 mock-resource-text" style={{ minHeight: "60px" }}>
    {isRecording ? (
      <>
      <div className="d-flex align-items-center justify-content-center">
        <img src={stopImage} alt="Stop Recording" style={{ height: "65px", width: "65px", objectFit: "contain" }} />
        <p className="text-center p-0 m-0" style={{ fontSize: "20px", marginLeft: "10px" }}>
          Recording... {recordingTimeLeft}s left
        </p>
      </div>
      </>
    ) : secondCount > 0 ? (
      <div className="d-flex justify-content-center align-items-center">
        <img src={grayImage} alt="Not Recording" style={{ height: "65px", width: "65px", objectFit: "contain" }} />
        <p className="text-center p-0 m-0" style={{ fontSize: "20px", marginLeft: "10px" }}>
          Recording starts in {secondCount} seconds
        </p>
      </div>
    ) : recordCount >= 30 ? (
      <div className="d-flex justify-content-center align-items-center">
        <img src={grayImage} alt="Recording Complete" style={{ height: "65px", width: "65px", objectFit: "contain" }} />
        <p className="text-center p-0 m-0" style={{ fontSize: "20px", marginLeft: "10px" }}>
          Recording Complete
        </p>
      </div>
    ) : (
      <div className="d-flex justify-content-center align-items-center">
        <img src={grayImage} alt="Ready" style={{ height: "65px", width: "65px", objectFit: "contain" }} />
        <p className="text-center p-0 m-0" style={{ fontSize: "20px", marginLeft: "10px" }}>
          Ready
        </p>
      </div>
    )}
  <div 
      className="d-flex align-items-center justify-content-center" 
      style={{ 
        width: "100%", 
        maxWidth: "600px", 
        height: "60px",
        padding: "10px 20px",
        
      }}
    >
      <MicWaveform
        key={waveformKey}
        progressValue={recordingProgress}
        mockColor={"#0081A4"}
        time={isRecording ? recordingTimeLeft : -1}
      />
    </div>
  </div>
)}
      <br />
      {blobURL && false && (
        <Row>
          <Col className="ml-auto mr-auto text-center" md="10">
            <audio src={blobURL} controls="controls" />
          </Col>
        </Row>
      )}
      <Row>
        <Col className="ml-auto mr-auto" md="10">
          <div className="intro-div mock-resource-text">
            <p>
              Please introduce yourself. For example you could talk one or more of the following
            </p>
            <ul>
              <li>Your interests</li>
              <li>Your plans for future study</li>
              <li>Why you want to study abroad</li>
              <li>Why you need to learn english</li>
              <li>Why you choose this test</li>
            </ul>
          </div>
        </Col>
      </Row>
      {!props.resultMode && soundStatus && (
        <Sound
          url={`${s3base}/ptedata/ptemedia/beep.mp3`}
          playStatus={Sound.status.PLAYING}
          onFinishedPlaying={handleSongFinishedPlaying}
          onError={handleSongFinishedPlaying}
        />
      )}
      
     
    </>
  )
};

export default IntroTest;